import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  GET_SURVEYTEMPLATEDETAIL,
  DELETE_SURVEYTEMPLATEDETAIL,
  UPDATE_SURVEYTEMPLATEDETAIL,
  ADD_NEW_SURVEYTEMPLATEDETAIL,
} from "./actionType";

import {
  getSurveyTemplateDetailSuccess,
  getSurveyTemplateDetailFail,
  deleteSurveyTemplateDetailSuccess,
  deleteSurveyTemplateDetailFail,
  updateSurveyTemplateDetailSuccess,
  updateSurveyTemplateDetailFail,
  addSurveyTemplateDetailSuccess,
  addSurveyTemplateDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveSurveyTemplateDetailApi,
  getSurveyTemplateDetailApi,
  updateSurveyTemplateDetailApi,
  deleteSurveyTemplateDetailApi,
  addNewSurveyTemplateDetailApi,
} from "../../helpers/backend_helper";

function* getSurveyTemplateDetail({ payload: surveyTemplateDetail }) {
  try {
    const response = yield call(
      getSurveyTemplateDetailApi,
      surveyTemplateDetail
    );
    yield put(
      getSurveyTemplateDetailSuccess(GET_SURVEYTEMPLATEDETAIL, response.data)
    );
  } catch (error) {
    yield put(getSurveyTemplateDetailFail(GET_SURVEYTEMPLATEDETAIL, error));
  }
}

function* onUpdateSurveyTemplateDetail({ payload: surveyTemplateDetail }) {
  try {
    if (surveyTemplateDetail.setApprove) {
      const response = yield call(
        approveSurveyTemplateDetailApi,
        surveyTemplateDetail
      );
      yield put(updateSurveyTemplateDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(
        updateSurveyTemplateDetailApi,
        surveyTemplateDetail
      );
      yield put(updateSurveyTemplateDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSurveyTemplateDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSurveyTemplateDetail({ payload: surveyTemplateDetail }) {
  try {
    const response = yield call(
      deleteSurveyTemplateDetailApi,
      surveyTemplateDetail
    );
    yield put(
      deleteSurveyTemplateDetailSuccess({ surveyTemplateDetail, ...response })
    );
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSurveyTemplateDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSurveyTemplateDetail({ payload: surveyTemplateDetail }) {
  try {
    const response = yield call(
      addNewSurveyTemplateDetailApi,
      surveyTemplateDetail
    );
    yield put(addSurveyTemplateDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSurveyTemplateDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetSurveyTemplateDetail() {
  yield takeEvery(GET_SURVEYTEMPLATEDETAIL, getSurveyTemplateDetail);
}

export function* watchUpdateSurveyTemplateDetail() {
  yield takeEvery(UPDATE_SURVEYTEMPLATEDETAIL, onUpdateSurveyTemplateDetail);
}

export function* watchDeleteSurveyTemplateDetail() {
  yield takeEvery(DELETE_SURVEYTEMPLATEDETAIL, onDeleteSurveyTemplateDetail);
}

export function* watchAddNewSurveyTemplateDetail() {
  yield takeEvery(ADD_NEW_SURVEYTEMPLATEDETAIL, onAddNewSurveyTemplateDetail);
}

function* surveyTemplateDetailSaga() {
  yield all([
    fork(watchGetSurveyTemplateDetail),
    fork(watchDeleteSurveyTemplateDetail),
    fork(watchUpdateSurveyTemplateDetail),
    fork(watchAddNewSurveyTemplateDetail),
  ]);
}

export default surveyTemplateDetailSaga;
